import PropTypes from 'prop-types';

import './DummyTileDragOverlay.css';

/**
 * DragOverlay component for DummyTile - optimized to prevent image flickering
 * @component
 */
const DummyTileDragOverlay = ({ card, activeSampleId = 0, updSampleId = 0, cutoffPrice = 0 }) => {
	let re = new RegExp('/normal/', 'g');
	let smallImgUrl = card.image_normal_uri.replace(re, '/small/');

	// Suppress unused vars - kept for API compatibility
	void activeSampleId;
	void updSampleId;
	void cutoffPrice;

	return (
		<div className="dummy-tile-drag-overlay">
			<img
				alt={'Card: ' + card.name}
				height="204"
				loading="eager"
				src={smallImgUrl}
				width="146"
				onLoad={() => {}}
			/>
		</div>
	);
};

DummyTileDragOverlay.propTypes = {
	card: PropTypes.object.isRequired,
	activeSampleId: PropTypes.number,
	updSampleId: PropTypes.number,
	cutoffPrice: PropTypes.number,
};

export default DummyTileDragOverlay;
